import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { environment } from '../../../environments/environment';
import { XUXDrawerSidebarService } from '@app/xenial-ux/services';
import { Subscription } from '@shared/rx';
import { toDate } from '@shared/utils';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

@Component({
  selector: 'xux-footer',
  templateUrl: './xux-footer.component.html',
  styleUrls: ['./xux-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XUXFooterComponent implements OnInit, OnDestroy {
  @HostBinding('class') public footerClass: string;

  public I18n = I18n;

  public year: number = toDate().getFullYear();
  public build: string = environment.version;
  public subscriptions: Subscription[] = [];

  public constructor(
    private drawerSidebarService: XUXDrawerSidebarService,
    private changeDetectionRef: ChangeDetectorRef,
    private i18nService: XVII18nService,
  ) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.drawerSidebarService.slideState$.subscribe((val) => {
        this.footerClass = `sidebar-${val}`;
        this.changeDetectionRef.markForCheck();
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => {
      sub?.unsubscribe();
    });
  }
}
